import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";
import defaultitineraryimage from "../../../assets/Images/default-itinerary-image.jpg";

export const getAllQuotations = createAsyncThunk(
  "CustomQuotaion/FindAllCustomQuotaionStep1",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/FindAllCustomQuotaionStep1`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Quotations:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createQuotationStep1 = createAsyncThunk(
  "CustomQuotaion/InsertCustomQuotaionStep1",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/InsertCustomQuotaionStep1`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createQuotationStep2 = createAsyncThunk(
  "CustomQuotaion/InsertCustomQuotaionStep2",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/InsertCustomQuotaionStep2`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error inserting quotation step 2:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateQuotationStep1 = createAsyncThunk(
  "CustomQuotaion/UpdateCustomQuotaionStep1",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/UpdateCustomQuotaionStep1`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteQuotation = createAsyncThunk(
  "CustomQuotaion/DeleteCustomQuotaionStep1",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/DeleteCustomQuotaionStep1`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getQuotationByID = createAsyncThunk(
  "CustomQuotaion/FindByIDCustomQuotaionStep1",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/FindByIDCustomQuotaionStep1`,
        formData,
      );
      const result = response.data?.Data as any;
      return {
        ...result,

        StartDate: result?.StartDate
          ? moment(result?.StartDate, "YYYY-MM-DD")?.toDate()
          : "",
        EndDate: result?.EndDate
          ? moment(result?.EndDate, "YYYY-MM-DD")?.toDate()
          : "",
        PickUpPlace: result?.PickUpPlace,
        PickUpDate: result?.PickUpDate
          ? moment(result?.PickUpDate, "YYYY-MM-DD")?.toDate()
          : "",
        DropPlace: result?.DropPlace,
        DropDate: result?.DropDate
          ? moment(result?.DropDate, "YYYY-MM-DD")?.toDate()
          : "",
        AccommodationConversionRate: result?.AccommodationConversionRate
          ? +result?.AccommodationConversionRate
          : 1,
        TransportaionConversionRate: result?.TransportaionConversionRate
          ? +result?.TransportaionConversionRate
          : 1,
        MiscellaneousConversionRate: result?.MiscellaneousConversionRate
          ? +result?.MiscellaneousConversionRate
          : 1,
        SightSeenConversionRate: result?.SightSeenConversionRate
          ? +result?.SightSeenConversionRate
          : 1,
        AccommodationCurrencyID: result?.AccommodationCurrencyID
          ? +result?.AccommodationCurrencyID
          : 1,
        TransportaionCurrencyID: result?.TransportaionCurrencyID
          ? +result?.TransportaionCurrencyID
          : 1,
        MiscellaneousCurrencyID: result?.MiscellaneousCurrencyID
          ? +result?.MiscellaneousCurrencyID
          : 1,
        SightSeenCurrencyID: result?.SightSeenCurrencyID
          ? +result?.SightSeenCurrencyID
          : 1,
        CreatedOn: result?.CreatedOn
          ? moment(result?.CreatedOn, "YYYY-MM-DD").toDate()
          : "",
        Accommodations: result?.Accommodations
          ? result?.Accommodations?.map((accommodation: any) => {
              return {
                Place: accommodation?.Place ? accommodation?.Place : "",
                PlaceID: accommodation?.PlaceID ? accommodation?.PlaceID : null,
                MealType: accommodation?.MealType
                  ? accommodation?.MealType
                  : "",
                RoomType: accommodation?.RoomType
                  ? accommodation?.RoomType
                  : "",
                RoomCategoryName: accommodation?.RoomCategoryName
                  ? accommodation?.RoomCategoryName
                  : "",
                HotelName: accommodation?.HotelName
                  ? accommodation?.HotelName
                  : "",
                Hotel:
                  accommodation?.Hotel && accommodation?.Hotel !== "0"
                    ? accommodation?.Hotel
                    : "",
                hotel_options: accommodation?.hotel_options
                  ? accommodation?.hotel_options
                  : [],
                place_options: accommodation?.place_options
                  ? accommodation?.place_options
                  : [],
                CheckInDate: accommodation?.CheckInDate
                  ? moment(accommodation?.CheckInDate, "YYYY-MM-DD").toDate()
                  : "",
                CheckOutDate: accommodation?.CheckOutDate
                  ? moment(accommodation?.CheckOutDate, "YYYY-MM-DD").toDate()
                  : "",
                RoomTypeID: accommodation?.RoomTypeID
                  ? +accommodation?.RoomTypeID
                  : null,
                MealTypeID: accommodation?.MealTypeID
                  ? +accommodation?.MealTypeID
                  : null,
                TotalRoom: accommodation?.TotalRoom
                  ? +accommodation?.TotalRoom
                  : null,
                HotelAmount: accommodation?.HotelAmount
                  ? +accommodation?.HotelAmount
                  : null,
                HotelRate: accommodation?.HotelRate
                  ? +accommodation?.HotelRate
                  : null,
                CategoryID: accommodation?.CategoryID
                  ? +accommodation?.CategoryID
                  : null,
                HotelCategoryID: accommodation?.CategoryID
                  ? +accommodation?.CategoryID
                  : null,
              };
            })
          : [],
        Transportations: result?.Transportations
          ? result?.Transportations?.map((transportation: any) => {
              return {
                VehicleTypeID: transportation?.VehicleTypeID
                  ? +transportation?.VehicleTypeID
                  : null,
                Place: transportation?.Place ? transportation?.Place : "",
                PlaceID: transportation?.PlaceID
                  ? transportation?.PlaceID
                  : null,
                VehicleType: transportation?.VehicleType
                  ? transportation?.VehicleType
                  : "",
                FromDate: transportation?.FromDate
                  ? moment(transportation?.FromDate, "YYYY-MM-DD")?.toDate()
                  : "",
                ToDate: transportation?.ToDate
                  ? moment(transportation?.ToDate, "YYYY-MM-DD")?.toDate()
                  : "",
                Rate: transportation?.Rate ? +transportation?.Rate : null,
                Qty: transportation?.Qty ? +transportation?.Qty : null,
                Remarks: transportation?.Remarks ? transportation?.Remarks : "",
              };
            })
          : [],
        Miscellaneous: result?.Miscellaneous
          ? result?.Miscellaneous?.map((miscellaneous: any) => {
              return {
                Title: miscellaneous?.Title ? miscellaneous?.Title : "",
                TotalAmount: miscellaneous?.TotalAmount
                  ? +miscellaneous?.TotalAmount
                  : null,
              };
            })
          : [],
        SightSeen: result?.SightSeen
          ? result?.SightSeen?.map((sightseen: any) => {
              return {
                SightSeenID: sightseen?.SightSeenID
                  ? +sightseen?.SightSeenID
                  : null,
                Rate: sightseen?.Rate ? +sightseen?.Rate : null,
                SightSeenName: sightseen?.SightSeenName
                  ? sightseen?.SightSeenName
                  : "",
              };
            })
          : [],
        TourItinerary: result?.Itinary
          ? result?.Itinary?.map((itinerary: any) => {
              return {
                QuotationID: itinerary?.QuotationID
                  ? +itinerary?.QuotationID
                  : null,
                DayNo: itinerary?.DayNo ? +itinerary?.DayNo : null,
                PlaceID: itinerary?.PlaceID ? +itinerary?.PlaceID : null,
                ItinaryID: itinerary?.ItinaryID ? +itinerary?.ItinaryID : null,
                Description: itinerary?.Description
                  ? itinerary?.Description
                  : "",
                Facilty: itinerary?.Facilty ? itinerary?.Facilty : "",
                ItineraryTitle: itinerary?.ItineraryTitle
                  ? itinerary?.ItineraryTitle
                  : "",
                Place: itinerary?.Place ? itinerary?.Place : "",
                FacilityName: itinerary?.FacilityName
                  ? itinerary?.FacilityName
                  : "",
                ItineraryImage: itinerary?.ItineraryImage
                  ? itinerary?.ItineraryImage
                  : defaultitineraryimage,
              };
            })
          : [],
        HotelRooms: result?.HotelRooms ? result?.HotelRooms : [],
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const sendQuotationByEmail = createAsyncThunk(
  "CustomQuotaion/SendQuotation",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/SendQuotation`,
        payload,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error sending quotation by email:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getQuotationHistoryByParentID = createAsyncThunk(
  "CustomQuotaion/FindQuotationHistory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/FindQuotationHistory`,
        { ParentID: ID },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Quotation History:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllFlightQuotations = createAsyncThunk(
  "FlightQuotation/FindAllFlightQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FlightQuotation/FindAllFlightQuotation`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Quotations:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createFlightQuotation = createAsyncThunk(
  "FlightQuotation/InsertFlightQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FlightQuotation/InsertFlightQuotation`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateFlightQuotation = createAsyncThunk(
  "FlightQuotation/UpdateFlightQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FlightQuotation/UpdateFlightQuotation`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteFlightQuotation = createAsyncThunk(
  "FlightQuotation/DeleteFlightQuotation",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FlightQuotation/DeleteFlightQuotation`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getFlightQuotationByID = createAsyncThunk(
  "FlightQuotation/FindByIDFlightQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FlightQuotation/FindByIDFlightQuotation`,
        formData,
      );
      const result = response.data?.Data as any;
      return {
        ...result,
        DepartureDate: result?.DepartureDate
          ? moment(result?.DepartureDate, "YYYY-MM-DD")?.toDate()
          : null,
        DepartureTime: result?.DepartureTime
          ? moment(result?.DepartureTime, "HH:mm")?.toDate()
          : "",
        ArrivalDate: result?.ArrivalDate
          ? moment(result?.ArrivalDate, "YYYY-MM-DD")?.toDate()
          : null,
        ArrivalTime: result?.ArrivalTime
          ? moment(result?.ArrivalTime, "HH:mm")?.toDate()
          : "",
        ReturnDepartureDate: result?.ReturnDepartureDate
          ? moment(result?.ReturnDepartureDate, "YYYY-MM-DD")?.toDate()
          : null,
        ReturnDepartureTime: result?.ReturnDepartureTime
          ? moment(result?.ReturnDepartureTime, "HH:mm")?.toDate()
          : "",
        ReturnArrivalDate: result?.ReturnArrivalDate
          ? moment(result?.ReturnArrivalDate, "YYYY-MM-DD")?.toDate()
          : null,
        ReturnArrivalTime: result?.ReturnArrivalTime
          ? moment(result?.ReturnArrivalTime, "HH:mm")?.toDate()
          : "",
        ValidUntil: result?.ValidUntil
          ? moment(result?.ValidUntil, "YYYY-MM-DD")?.toDate()
          : null,
        IsTCSApplicable:
          result?.TCSAmount && result?.TCSAmount > 0 ? true : false,
        return_from_place_options:
          result?.TripType === "Two Way" ? result?.to_place_options || [] : [],
        return_to_place_options:
          result?.TripType === "Two Way"
            ? result?.from_place_options || []
            : [],
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getFlightQuotationHistoryByParentID = createAsyncThunk(
  "FlightQuotation/FindQuotationHistory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FlightQuotation/FindQuotationHistory`,
        { ParentID: ID },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Quotation History:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllHotelQuotations = createAsyncThunk(
  "HotelQuotation/FindAllHotelQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelQuotation/FindAllHotelQuotation`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Hotel Quotations:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createHotelQuotation = createAsyncThunk(
  "HotelQuotation/InsertHotelQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelQuotation/InsertHotelQuotation`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating hotel quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateHotelQuotation = createAsyncThunk(
  "HotelQuotation/UpdateHotelQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelQuotation/UpdateHotelQuotation`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating hotel quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteHotelQuotation = createAsyncThunk(
  "HotelQuotation/DeleteHotelQuotation",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelQuotation/DeleteHotelQuotation`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting hotel quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getHotelQuotationByID = createAsyncThunk(
  "HotelQuotation/FindByIDHotelQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelQuotation/FindByIDHotelQuotation`,
        formData,
      );
      const result = response.data?.Data as any;
      return {
        ...result,
        CheckInDate: result?.CheckInDate
          ? moment(result?.CheckInDate, "YYYY-MM-DD")?.toDate()
          : null,
        CheckOutDate: result?.CheckOutDate
          ? moment(result?.CheckOutDate, "YYYY-MM-DD")?.toDate()
          : null,
        // CheckInTime: result?.CheckInTime
        //   ? moment(result?.CheckInTime, "HH:mm:ss")?.toDate()
        //   : null,
        // CheckOutTime: result?.CheckOutTime
        //   ? moment(result?.CheckOutTime, "HH:mm:ss")?.toDate()
        //   : null,
        ExpiryDate: result?.ExpiryDate
          ? moment(result?.ExpiryDate, "YYYY-MM-DD")?.toDate()
          : null,
        HotelRooms: result?.HotelRooms ? result?.HotelRooms : [],
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching hotel quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getHotelQuotationHistoryByParentID = createAsyncThunk(
  "HotelQuotation/FindHotelQuotationHistory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelQuotation/FindHotelQuotationHistory`,
        { ParentID: ID },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Quotation History:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

//  Visa
export const getAllVisaQuotations = createAsyncThunk(
  "VisaQuotation/FindAllVisaQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaQuotation/FindAllVisaQuotation`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Visa Quotations:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createVisaQuotation = createAsyncThunk(
  "VisaQuotation/InsertVisaQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaQuotation/InsertVisaQuotation`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating visa quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateVisaQuotation = createAsyncThunk(
  "VisaQuotation/UpdateVisaQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaQuotation/UpdateVisaQuotation`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating visa quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteVisaQuotation = createAsyncThunk(
  "VisaQuotation/DeleteVisaQuotation",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaQuotation/DeleteVisaQuotation`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting visa quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getVisaQuotationByID = createAsyncThunk(
  "VisaQuotation/FindByIDVisaQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaQuotation/FindByIDVisaQuotation`,
        formData,
      );
      const result = response.data?.Data as any;
      return {
        ...result,
        AdditionalServicesID: result?.AdditionalServicesID
          ? result?.AdditionalServicesID?.split(", ")?.map((e: any) => +e)
          : [],
        DocumentsID: result?.DocumentsID
          ? result?.DocumentsID?.split(", ")?.map((e: any) => +e)
          : [],
        DOB: result?.DOB ? moment(result?.DOB, "YYYY-MM-DD")?.toDate() : null,
        TravelDate: result?.TravelDate
          ? moment(result?.TravelDate, "YYYY-MM-DD")?.toDate()
          : null,
        PassportExpiryDate: result?.PassportExpiryDate
          ? moment(result?.PassportExpiryDate, "YYYY-MM-DD")?.toDate()
          : null,
        ExpiryDate: result?.ExpiryDate
          ? moment(result?.ExpiryDate, "YYYY-MM-DD")?.toDate()
          : null,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching visa quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getVisaQuotationHistoryByParentID = createAsyncThunk(
  "VisaQuotation/FindVisaQuotationHistory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaQuotation/FindVisaQuotationHistory`,
        { ParentID: ID },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Visa Quotation History:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllHotelsForDropdown = createAsyncThunk(
  "Hotels/FindAllHotelsForDropdown",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Hotels/FindAllHotelsForDropdown`,
        formData,
      );
      return response.data;
    } catch (error: any) {
      console.error("Error updating visa quotation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getCustomQuotationMessageForCopy = createAsyncThunk(
  "CustomQuotaion/WhatsAppFormatQuotationList",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CustomQuotaion/WhatsAppFormatQuotationList`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error get Quotation for copy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getFlightQuotationMessageForCopy = createAsyncThunk(
  "FlightQuotation/GetWhatsAppFormattedFlightQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FlightQuotation/GetWhatsAppFormattedFlightQuotation`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error get Quotation for copy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getHotelQuotationMessageForCopy = createAsyncThunk(
  "HotelQuotation/GetWhatsAppFormattedHotelQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelQuotation/GetWhatsAppFormattedHotelQuotation`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error get Quotation for copy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getVisaQuotationMessageForCopy = createAsyncThunk(
  "VisaQuotation/GetWhatsAppFormattedVisaQuotation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaQuotation/GetWhatsAppFormattedVisaQuotation`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error get Quotation for copy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
